export const moveBackword = (currentStep, setCurrentStep, lastStep = 0, setPreveStep) => {
  if (currentStep === 0) return setCurrentStep(lastStep);
  else { return setCurrentStep((prevStep) => currentStep - 1), setPreveStep((prevStep) => currentStep - 1)}
};
